import { ensureError, ensureHelp, ensureLabel, INPUT_BASE_CLASS, type FieldType } from './base.js';
import { validateRequired } from '../validation.js';
import { withCustomMessage } from './text.js';

export const selectType: FieldType = {
  render(ctx) {
    ensureLabel(ctx.host, ctx.label, ctx.required);

    let select = ctx.host.querySelector<HTMLSelectElement>(':scope > select');
    // Если AI/юзер положил <option> прямо в <plp-field> — собираем их в <select>.
    if (!select) {
      select = document.createElement('select');
      select.className = INPUT_BASE_CLASS;
      const looseOptions = Array.from(
        ctx.host.querySelectorAll<HTMLOptionElement>(':scope > option')
      );
      for (const opt of looseOptions) {
        select.appendChild(opt);
      }
      ctx.host.insertBefore(select, ctx.host.querySelector(':scope > .plp-field-error'));
    }
    select.name = ctx.name;
    select.required = ctx.required;
    if (ctx.defaultValue !== undefined && !select.value) {
      select.value = ctx.defaultValue;
    }
    ensureError(ctx.host);
    ensureHelp(ctx.host, ctx.help);
  },

  getValue(ctx) {
    return ctx.host.querySelector<HTMLSelectElement>(':scope > select')?.value ?? '';
  },

  validate(ctx) {
    const value = String(this.getValue(ctx));
    if (ctx.required) return withCustomMessage(validateRequired(value), ctx);
    return { valid: true };
  },

  shouldSubmit() {
    return true;
  },

  setDisabled(ctx, disabled) {
    const select = ctx.host.querySelector<HTMLSelectElement>(':scope > select');
    if (select) select.disabled = disabled;
  },
};
